'use client'

import { useEffect } from 'react'

import FeedHome from '@/features/veluvit/components/home/feed-home'
import { useUiStore } from '@/features/veluvit/stores/ui.store'

import type { ProductType } from '@/features/veluvit/types/catalog.types'

/** 홈(캐릭터 / 스토리) — 모바일 · PC 같은 피드 홈 하나(FeedHome), 폭만 다르다 */
export default function HomeScreen({ ptype }: { ptype: ProductType }) {
  useEffect(() => {
    useUiStore.getState().set({ homeStory: ptype === '스토리챗' })
  }, [ptype])

  return <FeedHome ptype={ptype} />
}
